import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokBrandPageType } from '../../storyblok'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

import { StoryblokBrandHeader } from './components/StoryblokBrandHeader'

export const StoryblokBrandPage: FC<
  StoryblokComponentProps<StoryblokBrandPageType>
> = ({ blok }) => {
  const { body, title, variant = 'content' } = blok

  return (
    <main
      {...storyblokEditable(blok)}
      className={clsx(
        'grid grid-cols-1',
        variant === 'content' && 'gap-3 py-4 desktop:gap-6 desktop:py-6',
      )}
      data-qa-id="brand-page"
    >
      {variant === 'content' && <StoryblokBrandHeader title={title} />}
      <StoryblokComponentsRenderer bloks={body} />
    </main>
  )
}
